<template>
  <v-container fluid >
    <div class="text-h5 font-weight-bold pl-4">Klasus - klasifikacije proizvoda po djelatnostima Republike Hrvatske</div>
        <KlasusSearch />
       <v-card outlined>
        <v-card-title>
          Odaberite razinu djelatnosti od 1 do 5
        </v-card-title>
          <KlasusLevel1 />
       </v-card>
  </v-container>
</template>

<script>

import KlasusLevel1 from './KlasusLevel1.vue'
import KlasusSearch from "./KlasusSearch.vue";

export default {
  name: 'klasusindex',
  data () {
    return {

    }
  },
  async mounted () {
    
  },
  methods: {


  },
  computed: {

  },
  watch: {

  },
  components: {
    KlasusLevel1,
    KlasusSearch
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
